












import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PatternKeepRatioController extends Vue 
{
    @Prop() layer! : RectangleLayer | CircleLayer | PolygonLayer;

    private static readonly KEEP_RATIO = ["縦横比固定ON", "縦横比固定OFF"];

    private get keepRatioText()
    {
        var keepRatio = this.layer.keepRatio == 0 ? 0 : 1;
        return PatternKeepRatioController.KEEP_RATIO[keepRatio];
    }

    private changeKeepRatio()
    {
        var keepRatio = this.layer.keepRatio == 0 ? 0 : 1;
        var newValue = keepRatio + 1;
        if(newValue > 1) { newValue = 0; }
        this.changeLayerProperty("keepRatio", newValue, true, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
